import React from 'react';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1 className="fade-in">أهلاً بكم في عالم اللغة الإنجليزية للأطفال</h1>
          <p className="fade-in">معاً نجعل تعلم اللغة الإنجليزية ممتعاً وسهلاً لأطفالكم</p>
          <Link to="/games" className="btn bounce">استكشف الألعاب التعليمية</Link>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">لماذا تختارنا؟</h2>
          <div className="card-container">
            <div className="card">
              <div className="card-content">
                <h3 className="card-title">تعليم ممتع</h3>
                <p className="card-text">نقدم طرقاً مبتكرة وممتعة لتعليم اللغة الإنجليزية تجعل الأطفال يحبون التعلم.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-content">
                <h3 className="card-title">منهج متكامل</h3>
                <p className="card-text">منهجنا يغطي جميع مهارات اللغة: الاستماع، التحدث، القراءة والكتابة بطريقة متوازنة.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-content">
                <h3 className="card-title">بيئة محفزة</h3>
                <p className="card-text">نوفر بيئة تعليمية إيجابية تشجع الأطفال على المشاركة والإبداع.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section games-section">
        <div className="container">
          <h2 className="section-title">الألعاب التعليمية</h2>
          <p>استكشف مجموعتنا من الألعاب التعليمية الممتعة التي تساعد الأطفال على تعلم اللغة الإنجليزية بسهولة.</p>
          <div className="card-container">
            <div className="card">
              <div className="card-content">
                <h3 className="card-title">لعبة الحروف</h3>
                <p className="card-text">تعلم الحروف الإنجليزية بطريقة ممتعة وتفاعلية.</p>
                <Link to="/games" className="btn">العب الآن</Link>
              </div>
            </div>
            <div className="card">
              <div className="card-content">
                <h3 className="card-title">لعبة الكلمات</h3>
                <p className="card-text">اكتشف كلمات جديدة وتعلم معانيها من خلال الصور.</p>
                <Link to="/games" className="btn">العب الآن</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">أهمية ترغيب الطفل في تعلم اللغة الإنجليزية</h2>
          <div className="card">
            <div className="card-content">
              <p>
                تعلم اللغة الإنجليزية في سن مبكرة يفتح آفاقاً واسعة للأطفال في المستقبل. من خلال جعل عملية التعلم ممتعة ومشوقة، 
                نساعد الأطفال على بناء علاقة إيجابية مع اللغة تستمر معهم مدى الحياة. أسلوبنا التعليمي يركز على:
              </p>
              <ul>
                <li>تقديم المحتوى بطريقة مرحة تناسب اهتمامات الأطفال</li>
                <li>استخدام الألعاب والأنشطة التفاعلية لتعزيز التعلم</li>
                <li>تشجيع الإبداع والتفكير النقدي أثناء تعلم اللغة</li>
                <li>بناء الثقة من خلال التعزيز الإيجابي والدعم المستمر</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section tips-section">
        <div className="container">
          <h2 className="section-title">نصائح للأهالي</h2>
          <p>اكتشف كيف يمكنك دعم رحلة طفلك في تعلم اللغة الإنجليزية.</p>
          <Link to="/tips" className="btn">اقرأ المزيد من النصائح</Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
